import React from "react";
import { Alert } from "react-bootstrap";
import { BsExclamationTriangle } from "react-icons/bs";
import "primeicons/primeicons.css";

export const AVISO_GESTION_MATERIAS_HTML = `
  <div style="background-color: #fff3cd; color: #856404; padding: 15px; border-radius: 5px; text-align: left; font-size: 0.9rem; border: 1px solid #ffeeba; margin-top: 10px;">
    <h5 style="margin-top: 0; margin-bottom: 0.5rem;"><strong>Aviso: Gestión de Materias y Calendario de Pagos</strong></h5>
    <p>Se informa que desde el <strong>14/07/26 hasta el 15/09/26 inclusive</strong>, estará habilitada en el <strong>Portal de Alumnos</strong> (único medio para realizar cambios) la autogestión de <strong>altas, bajas y modificaciones de materias.</strong></p>
    <p><strong><i class="pi pi-exclamation-triangle" style="margin-right: 5px;"></i>Importante:</strong> El <strong>15/09/26</strong> es la fecha límite definitiva para realizar bajas. Finalizado este plazo, las cuotas se cobrarán según las materias registradas a esa fecha, sin excepción.</p>
    <p>Las cuotas se facturan según las materias inscriptas al momento de la emisión. Cualquier modificación retroactiva en el monto se ajustará automáticamente en el siguiente mes.</p>
    <hr style="border-top: 1px solid #ffeeba;">
    <h6 style="margin-bottom: 0.5rem;"><strong>Cronograma de Vencimientos:</strong></h6>
    <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0.75rem;">
      <<li>&bull; <strong>Matrícula (según corresponda) y Cuota 7 (Septiembre):</strong> Facturación: 25/08/26 | <strong>Vencimiento: 10/09/26</strong></li>
      <li>&bull; <strong>Cuota 8 (Octubre):</strong> Facturación: 25/09/26 | <strong>Vencimiento: 10/10/26</strong></li>
      <li>&bull; <strong>Próximas cuotas:</strong> Vencerán el <strong>día 10 de cada mes</strong>.</li>
    </ul>
    <hr style="border-top: 1px solid #ffeeba;">
    <h6 style="margin-bottom: 0.5rem;"><strong>Medios de Pago:</strong></h6>
    <ul style="list-style-type: none; padding-left: 0; margin-bottom: 0.75rem;">
      <li>&bull; <strong>Pago electrónico:</strong> Disponible las 24 hs en el portal web de pagos.</li>
      <li>&bull; <strong>Pago mis cuentas:</strong> del 1 al 10 de cada mes.</li>
      <li>&bull; <strong>Pago presencial:</strong> Solo días hábiles.</li>
    </ul>
    <p style="margin-bottom: 0;"><small>Se recuerda que posterior al vencimiento comenzarán a correr los intereses por pago fuera de fecha.</small></p>
  </div>
`;

export default function AvisoGestionMaterias() {
  return (
    <Alert className="shadow-sm" variant="warning">
      <h5><strong>Aviso: Gestión de Materias y Calendario de Pagos</strong></h5>
      <p>
        Se informa que desde el <strong>14/07/26 hasta el 15/09/26 inclusive</strong>,
        estará habilitada en el <strong>Portal de Alumnos</strong> (único medio para realizar
        cambios) la autogestión de altas, bajas y modificaciones de materias.
      </p>
      <p>
        
          <BsExclamationTriangle style={{ marginRight: "5px", verticalAlign: "middle" }} />
          <strong>Importante:</strong> El <strong>15/09/26</strong> es la fecha límite definitiva para realizar bajas. Finalizado
          este plazo, las cuotas se cobrarán según las materias registradas a esa
          fecha, sin excepción.
        
      </p>
      <p>
        Las cuotas se facturan según las materias inscriptas al momento de la
        emisión. Cualquier modificación retroactiva en el monto se ajustará
        automáticamente en el siguiente mes.
      </p>
      <hr />
      <h6><strong>Cronograma de Vencimientos:</strong></h6>
      <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
        <li>
          • <strong>Matrícula (según corresponda) y Cuota 7 (Septiembre):</strong>{" "}
          Facturación: 25/08/26 | <strong>Vencimiento: 10/09/26</strong>
        </li>
        <li>
          • <strong>Cuota 8 (Octubre):</strong>{" "}
          Facturación: 25/09/26 | <strong>Vencimiento: 10/10/26</strong>
        </li>
        <li>
          • <strong>Próximas cuotas: </strong>Vencerán el día 10 de cada mes.
        </li>
      </ul>
      <hr />
      <h6><strong>Medios de Pago:</strong></h6>
      <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
        <li>• <strong>Pago electrónico:</strong> Disponible las 24 hs en el portal web de pagos.</li>
        <li>• <strong>Pago mis cuentas</strong> del 1 al 10 de cada mes.</li>
        <li>• <strong>Pago presencial:</strong> Solo días hábiles.</li>
      </ul>
      <p style={{ marginBottom: 0 }}>
        <small><strong>Se recuerda que posterior al vencimiento comenzarán a correr los intereses por pago fuera de fecha.</strong></small>
      </p>
    </Alert>
  );
}